"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-9.646-2.354a.5.5 0 0 0-.708.708L11.293 12l-1.647 1.646a.5.5 0 0 0 .708.708L12 12.707l1.646 1.647a.5.5 0 0 0 .708-.708L12.707 12l1.647-1.646a.5.5 0 0 0-.708-.708L12 11.293z"
}), 'ClearCircleFilled');
